export default {
  // 列表頁
  '宣传页配置': '宣傳頁配置',
  '类型': '類型',
  '全部': '全部',
  '线上赛': '線上賽',
  '组织测试': '組織測試',
  '运动会': '運動會',
  '视频': '視頻',
  '图片': '圖片',
  '链接': '鏈接',
  '发布时间': '發布時間',
  '状态': '狀態',
  '搜索': '搜索',
  '请输入标题搜索': '請輸入標題搜索',
  '查询': '查詢',
  '重置': '重置',
  '新增': '新增',
  '标题': '標題',
  '预览图': '預覽圖',
  '关联对象': '關聯對象',
  '排序': '排序',
  '创建人': '創建人',
  '创建时间': '創建時間',
  '发布人': '發布人',
  '暂无图片': '暫無圖片',
  '操作': '操作',
  '编辑': '編輯',
  '删除': '刪除',
  '启用': '啟用',
  '停用': '停用',
  '确认要停用': '確認要停用',
  '确认要停用{name}': '確認要停用{name}',
  '确认要删除': '確認要刪除',
  '确认要删除{name}吗？': '確認要刪除{name}嗎？',
  '吗？': '嗎？',
  '删除成功！': '刪除成功！',
  '知道了': '知道了',
  '本机构资源空间已不足，请及时联系运营人员': '本機構資源空間已不足，請及時聯繫運營人員',

  // 新增/編輯頁
  '基本信息': '基本信息',
  '请输入标题': '請輸入標題',
  '请选择类型': '請選擇類型',
  '请选择关联对象': '請選擇關聯對象',
  '内容设置': '內容設置',
  '封面图': '封面圖',
  '支持jpg_jpeg_png格式，建议比例为16：9，最大不超过5M': '支持jpg/jpeg/png格式，建議比例為16：9，最大不超過5M',
  '视频列表': '視頻列表',
  '支持mp4格式，最多上传5个视频': '支持MP4/AVI/WMV格式，建議比例為16：9，最大不超過500M，最多5個',
  '图片列表': '圖片列表',
  '支持jpg_jpeg_png格式，建议比例为16：9，最大不超过20M，最多10张': '支持jpg/jpeg/png格式，建議比例為16：9，最大不超過20M，最多10張',
  '链接地址': '鏈接地址',
  '请输入链接地址': '請輸入鏈接地址',
  '请输入可用链接': '請輸入可用鏈接',
  '发布设置': '發布設置',
  '请输入排序': '請輸入排序',
  '发布': '發布',
  '返回': '返回',
  '是否返回上一页？': '是否返回上一頁？',
  '编辑成功': '編輯成功',
  '新增成功': '新增成功',
  '加载数据失败：': '加載數據失敗：',
  '请上传封面图': '請上傳封面圖',
  '请上传视频': '請上傳視頻',
  '请上传图片': '請上傳圖片',
}
